<template>
  <el-container
    class="container-list is-vertical page-order-detail"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;">
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item :to="{ path: `${$route.query.isTeamBuying ? '/order-of-teambuying' : '/order'}`, query:{page:$route.query.frompage || 1, filteringStatus:$route.query.filteringStatus, filteringDateRange:$route.query.filteringDateRange, keyword:$route.query.keyword, filteringTeamBuyingID: $route.query.filteringTeamBuyingID} }">訂單管理 P{{$route.query.frompage || 1}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <template slot="right">
        <el-button @click="onExportPDF" style="margin-right: 20px;">檢視/匯出</el-button>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" style="padding-top: 15px">
        <el-row v-if="order">
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="header-with-status">
                <span>訂單資訊</span>
                <div class="header-with-status">
                  <el-select v-model="orderStatus" placeholder="更改訂單狀態">
                    <el-option
                      v-for="option in orderStatusOptions"
                      :key="`訂單狀態-${option}`"
                      :label="option"
                      :value="option"
                      :disabled="option===order.OrderStatus">
                    </el-option>
                  </el-select>

                  <el-button @click="isShowEditOrderModal=true" type="text" style="margin-left: 8px;">編輯</el-button>
                </div>
              </div>

              <table class="table-info">
                <tr><th>訂單編號</th><td>{{order | getOrderID}}</td></tr>
                <tr><th>訂單日期</th><td>{{order.CreatedAt | moment}}</td></tr>
                <tr><th>訂單狀態</th><td :class="`order-status ${order.OrderStatus}`">{{order.OrderStatus}}</td></tr>
                <tr><th>訂單備註</th><td v-html="order.Remark.replaceAll('\n', '<br>')"></td></tr>
                <tr><th>折扣碼</th><td>{{order.CouponCode}}</td></tr>
                <tr><th>配送時段</th><td>{{order.DeliveryTime}}</td></tr>
                <tr><th>貨到電聯</th><td>{{order.IsCallWhileArrived ? "YES" : "NO"}}</td></tr>
                <tr><th>送禮用</th><td>{{order.IsGift ? "YES" : "NO"}}</td></tr>
                <tr><th>發票類型</th><td>{{order.ReceiptType}}</td></tr>
                <tr v-if="order.ReceiptType=='紙本發票'"><th>抬頭/統編</th><td>{{order.ReceiptPaperCompanyTitle}}<br>{{order.ReceiptPaperTaxID}}</td></tr>
                <!-- LINE Pay 沒有電子發票 -->
                <tr v-if="order.ReceiptType=='電子發票'"><th>載具/統編</th><td><span v-if="order.ReceiptDigitalBarcode">/{{order.ReceiptDigitalBarcode}}</span><span v-else>用戶未輸入條碼，將使用「綠界登入載具」</span><br>{{order.ReceiptDigitalTaxID}}</td></tr>
                <tr v-if="order.ReceiptType=='電子發票'"><th>開發票時間</th><td>{{order.InvoiceWillIssueAt | moment}}</td></tr>
                <tr v-if="order.ReceiptType=='紙本發票'"><th>發票編號</th><td>{{order.TripleReceiptID}}</td></tr>
                <tr v-if="order.ReceiptType=='電子發票'"><th>開發票結果</th><td v-if="order.InvoiceIssueResult">
                  <span v-if="order.IsInvoiceIssueDone">
                    {{order.InvoiceIssueResult.InvoiceNo}}
                    <br>
                    隨機碼: {{order.InvoiceIssueResult.RandomNumber}}
                  </span>
                  <span v-else style="color:red">{{order.InvoiceIssueResult.ResponseMessage}}</span>
                  </td>
                </tr>
                <tr><th>訂單紅利</th>
                  <td v-if="order.Amount >= 1000">
                    <span v-if="order.BonusVoucher">
                      {{order.BonusVoucher.Amount}} ({{order.BonusVoucher.CreatedAt | dateFormat}})
                    </span>
                    <span v-else-if="order.OrderStatus == '已完成'">
                      將於 {{order | bonusWillSentAt}} 發送
                    </span>
                    <span v-else>
                      預計訂單完成3天後發送
                    </span>
                  </td>
                  <td v-else>N/A</td>
                </tr>
                <tr><th>管理員備註</th><td>{{order.AdminRemark}}</td></tr>
              </table>

            </el-card>

            <el-card class="box-card">
              <div slot="header" class="header-with-status">
                <span>付款資訊</span>
                <div class="header-with-status">
                  <el-select v-model="paymentStatus" placeholder="更改付款狀態">
                    <el-option
                      v-for="option in paymentStatusOptions"
                      :key="`付款狀態-${option}`"
                      :label="option"
                      :value="option"
                      :disabled="option===order.PaymentStatus || option=='超過付款時間'">
                    </el-option>
                  </el-select>

                  <!-- <el-button @click="isShowEditOrderModal=true" type="text" style="margin-left: 8px;">編輯</el-button> -->
                </div>
              </div>
              <table class="table-info">
                <!-- <tr><th class="bold" colspan="2">物流資訊: <a href="javascript:;" @click="isShowEditOrderDeliveryModal = true" class="btn-edit">編輯</a></th></tr> -->
                <tr><th style="padding-top: 10px;">付款狀態</th><td :class="`payment-status ${order.PaymentStatus}`">{{order.PaymentStatus}}</td></tr>
                <tr><th>付款方式</th><td>{{order.PaymentMethod}}</td></tr>
                <tr v-if="order.OrderPaymentInfo"><th>繳款資訊</th><td>
                    銀行代號：{{order.OrderPaymentInfo.BankCode}}
                    <br>
                    銀行帳號：{{order.OrderPaymentInfo.VAccount}}
                    <br>
                    繳費期限：{{order.OrderPaymentInfo.ExpireDate}}
                  </td></tr>
              </table>
            </el-card>

            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>訂購人資訊</span>
                <el-button v-if="order.UserID" @click="isShowUserAddeditModal=true" style="float: right; padding: 3px 0" type="text">編輯</el-button>
              </div>
              <table v-if="order.UserID" class="table-info">
                <tr><th>訂購人</th><td>{{order.User.Profile.Name}}</td></tr>
                <tr><th>電話號碼</th><td>{{order.User.Profile.Phone}}</td></tr>
                <tr><th>Email</th><td>{{order.User.Profile.Email}}</td></tr>
                <tr><th>生日</th><td>{{order.User.Profile.BirthYear}}/{{order.User.Profile.BirthMonth}}/{{order.User.Profile.BirthDay}}</td></tr>
              </table>
              <table v-else class="table-info">
                <tr><th colspan="2">[未註冊] {{order.BuyerInfo.Email}}</th></tr>
              </table>

            </el-card>
            <el-card class="box-card">
              <div slot="header" class="header-with-status">
                <span>配送資訊</span>
                <div class="header-with-status">
                  <el-select v-model="logisticsStatus" placeholder="更改物流狀態">
                    <el-option
                      v-for="option in logisticsStatusOptions"
                      :key="`物流狀態-${option}`"
                      :label="option"
                      :value="option"
                      :disabled="option===order.LogisticsStatus">
                    </el-option>
                  </el-select>

                  <!-- <el-button @click="isShowEditOrderModal=true" type="text" style="margin-left: 8px;">編輯</el-button> -->
                </div>
              </div>
              <table class="table-info">
                <tr><th class="bold" colspan="2">物流資訊: <a href="javascript:;" @click="isShowEditOrderDeliveryModal = true" class="btn-edit">編輯</a></th></tr>
                <tr><th style="padding-top: 10px;">送貨狀態</th><td style="padding-top: 1.5px;" :class="`logistics-status ${order.LogisticsStatus}`">{{order.LogisticsStatus}}</td></tr>
                <tr><th>送貨方式</th><td>{{order.Delivery}}</td></tr>
                <tr v-if="order.Delivery === '黑貓宅急便'"><th>黑貓物流ID</th><td>
                  <a v-if="order.TCatLogisticsID" :href="`https://www.t-cat.com.tw/inquire/TraceDetail.aspx?BillID=${order.TCatLogisticsID}`" target="_blank">{{order.TCatLogisticsID}} <i class="el-icon-top-right"></i></a>
                </td></tr>
                <tr><th>運送費用</th><td>{{order.ShippingCost}}</td></tr>

                <tr><th class="bold" colspan="2">寄件人資訊: <a href="javascript:;" @click="isShowEditSenderModal = true" class="btn-edit">編輯</a></th></tr>
                <tr><th style="padding-top: 10px;">寄件人</th><td style="padding-top: 10px;">{{order.BuyerInfo.Name}}</td></tr>
                <tr><th>寄件人電話</th><td>{{order.BuyerInfo.Phone}}</td></tr>
                <tr><th>寄件地址</th><td>{{order.BuyerInfo.PostalCode}}
                  {{order.BuyerInfo.County}}
                  {{order.BuyerInfo.Township}}
                  {{order.BuyerInfo.Village}}
                  {{order.BuyerInfo.Detail}}
                  </td></tr>

                <tr>
                  <th class="bold" colspan="2">收件人資訊:
                    <a v-if="!order.IsPickByCustomerSelf" href="javascript:;" @click="isShowEditReceiverModal = true" class="btn-edit">編輯</a>
                    <span v-else>自取</span>
                  </th>
                </tr>
                <tbody v-if="!order.IsPickByCustomerSelf">
                  <tr v-if="order.ReceiverInfoID == order.BuyerInfoID"><th colspan="2">(同寄件人)</th></tr>
                  <tr v-if="order.ReceiverInfoID != order.BuyerInfoID"><th style="padding-top: 10px;">收件人</th><td style="padding-top: 10px;">{{order.ReceiverInfo.Name}}</td></tr>
                  <tr v-if="order.ReceiverInfoID != order.BuyerInfoID"><th>收件人電話</th><td>{{order.ReceiverInfo.Phone}}</td></tr>
                  <tr v-if="order.ReceiverInfoID != order.BuyerInfoID"><th>收件地址</th><td>{{order.ReceiverInfo.PostalCode}}
                    {{order.ReceiverInfo.County}}
                    {{order.ReceiverInfo.Township}}
                    {{order.ReceiverInfo.Village}}
                    {{order.ReceiverInfo.Detail}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </el-card>
          </el-col>
          <el-col :span="12" style="overflow: hidden;">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>訂單資訊</span>
                <!-- <el-button style="float: right; padding: 3px 0" type="text">編輯</el-button> -->
              </div>

              <table class="table-cart-order-items datatable">
                <tbody  v-for="orderProduct in order.OrderProducts" :key="`order-detail-order-product-${orderProduct.ID}`">
                  <tr>
                    <th><img width="80" :src="getProductDataCoverImageURL(orderProduct.Product.Tw)"/></th><td>{{orderProduct.Product.Tw.Name}}</td>
                  </tr>
                  <tr>
                    <th>單價</th><td>NT$ {{orderProduct.Price|amountFormat}}</td>
                  </tr>
                  <tr>
                    <th>數量</th><td>{{orderProduct.Amount}}</td>
                  </tr>
                  <tr>
                    <th>小計</th><td>NT$ {{orderProduct.Price * orderProduct.Amount|amountFormat}}</td>
                  </tr>
                </tbody>
                <tbody  v-for="orderGift in order.OrderGifts" :key="`order-detail-order-gift-${orderGift.ID}`">
                  <tr>
                    <th><img width="80" :src="orderGift.Gift.ImageURL"/></th><td>{{orderGift.Gift.NameTw}}</td>
                  </tr>
                  <tr>
                    <th>單價</th><td>NT$ 0</td>
                  </tr>
                  <tr>
                    <th>數量</th><td>{{orderGift.Amount}}</td>
                  </tr>
                  <tr>
                    <th>小計</th><td>NT$ 0</td>
                  </tr>
                </tbody>
              </table>

              <div class="table-total-wrapper">
                  <table class="table-total">
                      <tr><th>數　量</th><td>{{order.OrderProducts.reduce((sum,o)=>sum+o.Amount, 0) + order.OrderGifts.reduce((sum,o)=>sum+o.Amount, 0)}}</td></tr>
                      <tr><th>小　計</th><td>NT$ {{order.Amount | amountFormat}}</td></tr>
                      <tr><th>購物金</th><td>-NT$ {{order.UsedVoucherAmount | amountFormat}}</td></tr>
                      <tr><th>折扣碼</th><td>-NT$ {{order.CouponDiscount | amountFormat}}</td></tr>
                      <tr><th>運　費</th><td>NT$ {{order.ShippingCost | amountFormat}}</td></tr>
                      <tr><th>總　計</th><td class="sum">NT$ {{order.PaidAmount | amountFormat}}</td></tr>
                  </table>
              </div>

            </el-card>

          </el-col>
        </el-row>

        <user-profile-editor-modal v-if="order && order.User" :isShow="isShowUserAddeditModal" @close="isShowUserAddeditModal = false" @submitted="onUserUpdated" :ori-obj="order.User"/>
        <modal-edit-contact v-if="order" title="編輯寄件人資訊" contact-type="sender" :order-i-d="order.ID" :is-show="isShowEditSenderModal" @close="isShowEditSenderModal=false" @submitted="onSenderUpdated" :ori-obj="order.BuyerInfo"/>
        <modal-edit-contact v-if="order" title="編輯收件人資訊" contact-type="receiver" :order-i-d="order.ID" :is-show="isShowEditReceiverModal" @close="isShowEditReceiverModal=false" @submitted="onReceiverUpdated" :ori-obj="order.ReceiverInfo"/>
        <modal-edit-order v-if="order" :is-show="isShowEditOrderModal" @close="isShowEditOrderModal=false" :ori-obj="order"/>
        <modal-edit-order-delivery v-if="order" :is-show="isShowEditOrderDeliveryModal" @close="isShowEditOrderDeliveryModal=false" :ori-obj="order"/>
        <modal-print v-if="order" :is-show="isShowPrintOrderModal" @close="isShowPrintOrderModal=false" :ori-obj="order"/>
      </el-main>
    </el-container>

  </el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
// mixin
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
// modal
import ModalEditOrder from './modal-edit-order'
import ModalEditOrderDelivery from './modal-edit-order-delivery'
import ModalEditContact from './modal-edit-contact'
import UserProfileEditorModal from '@/data/user/view/modal-editor-profile.vue'
import ModalPrint from './modal-print'
export default {
  mixins: [MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader,
    ModalEditContact,
    ModalEditOrder,
    ModalEditOrderDelivery,
    ModalPrint,
    UserProfileEditorModal
  },
  data () {
    return {
      order: null,
      isLoading: true,
      // status
      orderStatus: '',
      logisticsStatus: '',
      paymentStatus: '',
      // modal
      isShowEditSenderModal: false,
      isShowEditReceiverModal: false,
      isShowEditOrderModal: false,
      isShowEditOrderDeliveryModal: false,
      isShowUserAddeditModal: false,
      isShowPrintOrderModal: false,
      // options
      orderStatusOptions: [
        '處理中', '已確認', '已退貨', '已取消', '已完成'
      ],
      logisticsStatusOptions: [
        '備貨中', '已出貨', '已到貨', '已取貨', '退貨中', '已退貨', '已取消'
      ],
      paymentStatusOptions: [
        '已付款', '未付款', '付款失敗', '超過付款時間', '退款中', '已退款'
      ]
    }
  },
  computed: {
    orderID () {
      return this.$route.params.id
    },
    title () {
      return '訂單'
    }
  },
  methods: {
    onExportPDF () {
      this.isShowPrintOrderModal = true
    },
    onUserUpdated (payload) {
      this.$set(this.order.User, 'Profile', payload.Profile)
    },
    onSenderUpdated (contact) {
      this.$set(this.order, 'BuyerInfo', contact)
      this.$set(this.order, 'BuyerInfoID', contact.ID)
    },
    onReceiverUpdated (contact) {
      this.$set(this.order, 'ReceiverInfo', contact)
      this.$set(this.order, 'ReceiverInfoID', contact.ID)
    },
    getProductDataCoverImageURL (productData) {
      if (!productData.imagesJsonArr) productData.imagesJsonArr = JSON.parse(productData.Images)
      return (productData.imagesJsonArr[0] || {})['@1']
    }
  },
  created () {
    // query...
    this.$services.order.get(this, this.orderID).then(res => {
      this.order = res.data.result
    }).catch(this.$handleServiceError)
  },
  watch: {
    orderStatus () {
      if (this.orderStatus !== '') {
        let payload = { status: this.orderStatus }
        this.$services.order.updatOrderStatus(this, this.order.ID, payload).then(res => {
          let ok = res && res.data && res.data.status === 'ok'
          if (ok) {
            // 2021/12/09 訂單狀態更改為已取消時，若物流狀態為「備貨中」，自動改為「已取消」
            var logisticsStatusUpdateHint = ''
            if (payload.status === '已取消' && this.order.LogisticsStatus === '備貨中') {
              logisticsStatusUpdateHint = '，且物流狀態自動修改為「已取消」'
            }
            this.$message({
              message: `成功修改訂單狀態為「${payload.status}」${logisticsStatusUpdateHint}`,
              type: 'success'
            })
            this.orderStatus = ''
            if (payload.status === '已完成') this.$set(this.order, 'CompletedAt', moment().format())
            this.$set(this.order, 'OrderStatus', payload.status)
            if (logisticsStatusUpdateHint) {
              this.$set(this.order, 'LogisticsStatus', '已取消')
            }
          }
        }).catch(this.$handleServiceError)
      }
    },
    logisticsStatus () {
      if (this.logisticsStatus !== '') {
        let payload = { status: this.logisticsStatus }
        this.$services.order.updateLogisticsStatus(this, this.order.ID, payload).then(res => {
          let ok = res && res.data && res.data.status === 'ok'
          if (ok) {
            // 2021/12/09 物流狀態改為「已到貨」或「已取貨」時，訂單狀態自動改為「已完成」
            var orderStatusUpdateHint = ''
            if ((payload.status === '已到貨' || payload.status === '已取貨') && this.order.LogisticsStatus != '已完成') {
              // orderStatusUpdateHint = '，且訂單狀態自動修改為「已完成」'
              this.orderStatus = '已完成'
            }
            this.$message({
              message: `成功修改物流狀態為「${payload.status}」${orderStatusUpdateHint}`,
              type: 'success'
            })
            this.logisticsStatus = ''
            this.$set(this.order, 'LogisticsStatus', payload.status)
          }
        }).catch(this.$handleServiceError)
      }
    },
    paymentStatus () {
      if (this.paymentStatus !== '') {
        let payload = { status: this.paymentStatus }
        this.$services.order.updatePaymentStatus(this, this.order.ID, payload).then(res => {
          let ok = res && res.data && res.data.status === 'ok'
          if (ok) {
            this.$message({
              message: `成功修改付款狀態為「${payload.status}」`,
              type: 'success'
            })
            this.paymentStatus = ''
            this.$set(this.order, 'PaymentStatus', payload.status)
          }
        }).catch(this.$handleServiceError)
      }
    }
  },
  filters: {
    bonusWillSentAt (order) {
      // 加上4天，時間為00
      return moment(order.CompletedAt).add(4, 'days').format('YYYY/MM/DD')
    }
  }
}
</script>

<style>
.page-order-detail .el-card {
  margin: 0 auto 30px;
  border: solid 1px rgb(223, 223, 223);
  width: calc(100% - 15px);
  text-align: left;
}

.page-order-detail .el-card__header {
  background-color: rgb(247, 247, 247);
}

.page-order-detail .table-info {
  width: 100%;
}
.page-order-detail .table-info tr:not(:first-child) th,
.page-order-detail .table-info tr:not(:first-child) td {
  padding-top: 30px;
}
.page-order-detail .table-info th {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.46;
  letter-spacing: 1.04px;
  text-align: left;
  color: rgb(112, 112, 112);

  width: 80px;
}
.page-order-detail .table-info td {
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.47;
  letter-spacing: 1.2px;
  text-align: left;
  color: rgb(64, 62, 61);
}
.table-cart-order-items.datatable {
  margin-top: 0;
  border-top: none;
}

.btn-edit {
  color: #409EFF; /* primary */
  text-decoration: none;
}

a {
  color: #409EFF;
}

.header-with-status {
  height: 40px;display: flex;justify-content: space-between;align-items: center;
}
</style>
